import { Icon } from '@pfida-finance/ui/components';
import type { ReactNode } from 'react';
import { WIDGET_COLORS } from '../constants/colors';

export type CardHeaderVariant = 'default' | 'neutral' | 'warning' | 'success' | 'dip' | 'danger';

const VARIANT_STYLES: Record<
  CardHeaderVariant,
  { iconBg: string; iconColor: string; badgeBg: string; badgeColor: string }
> = {
  default: {
    iconBg: WIDGET_COLORS.primaryLight,
    iconColor: WIDGET_COLORS.primary,
    badgeBg: WIDGET_COLORS.purple.bg,
    badgeColor: WIDGET_COLORS.purple.text,
  },
  neutral: {
    iconBg: WIDGET_COLORS.gray.bg,
    iconColor: WIDGET_COLORS.gray.text,
    badgeBg: WIDGET_COLORS.gray.bg,
    badgeColor: WIDGET_COLORS.nearBlack,
  },
  warning: {
    iconBg: WIDGET_COLORS.amber.bg,
    iconColor: WIDGET_COLORS.amber.text,
    badgeBg: WIDGET_COLORS.amber.bg,
    badgeColor: WIDGET_COLORS.amber.text,
  },
  success: {
    iconBg: WIDGET_COLORS.green.bg,
    iconColor: WIDGET_COLORS.green.text,
    badgeBg: WIDGET_COLORS.green.bg,
    badgeColor: WIDGET_COLORS.green.text,
  },
  dip: {
    iconBg: WIDGET_COLORS.dip.bg,
    iconColor: WIDGET_COLORS.dip.text,
    badgeBg: WIDGET_COLORS.dip.bg,
    badgeColor: WIDGET_COLORS.dip.text,
  },
  danger: {
    iconBg: WIDGET_COLORS.red.bg,
    iconColor: WIDGET_COLORS.red.text,
    badgeBg: WIDGET_COLORS.red.bg,
    badgeColor: WIDGET_COLORS.red.text,
  },
};

type Props = {
  variant: CardHeaderVariant;
  badgeText: string;
  description?: ReactNode;
  descriptionColor?: string;
  descriptionWeight?: number;
};

export function WidgetCardHeader({ variant, badgeText, description, descriptionColor, descriptionWeight }: Props) {
  const { iconBg, iconColor, badgeBg, badgeColor } = VARIANT_STYLES[variant];

  return (
    <>
      <div className="flex items-center">
        <div
          className="w-11 h-11 rounded-full flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: iconBg }}
        >
          <Icon name="home" className="w-5 h-5" style={{ color: iconColor }} />
        </div>
        <span className="text-[21px] font-medium text-[#2c2c2c] ml-3.5 flex-1">SaveTogether</span>
        <span
          className="inline-flex items-center rounded-full text-[12px] font-semibold whitespace-nowrap"
          style={{ backgroundColor: badgeBg, color: badgeColor, padding: '12px 24px', lineHeight: 1 }}
        >
          {badgeText}
        </span>
      </div>
      {description && (
        <p
          className="text-base text-gray-500 mb-0"
          style={{ marginTop: '16px', color: descriptionColor, fontWeight: descriptionWeight }}
        >
          {description}
        </p>
      )}
    </>
  );
}
